import React from 'react';
import './Blog.css';

const Blog = () => {
  const blogPosts = [
    {
      id: 4,
      title: 'Coming Soon',
      date: 'March 7, 2025',
      excerpt: '',
      tags: ['Interests']
    }
  ];

  return (
    <div className="page blog-page">
      <h1 className="page-title">Blog</h1>
      <p className="page-description">
        Thoughts, ideas, and insights on technology, programming, and more.
      </p>
      
      <div className="blog-posts">
        {blogPosts.map(post => (
          <div key={post.id} className="blog-post-card">
            <h2>{post.title}</h2>
            <p className="post-date">{post.date}</p>
            <div className="post-tags">
              {post.tags.map((tag, index) => (
                <span key={index} className="tag">{tag}</span>
              ))}
            </div>
            <p className="post-excerpt">{post.excerpt}</p>
            <a href={`/blog/${post.id}`} className="read-more">Read More</a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog; 